<template>
  <div class="table-responsive hover-table">
    <table class="table table-striped">
      <thead>
      <tr>
        <td class="text-capitalize">{{$t("flexben.import.types.beneficiary")}}</td>
        <td>{{$t("flexben.general.status")}}</td>
        <td>{{$t("flexben.beneficiaries.fields.invitation_email")}}</td>
        <td>{{$t("flexben.import.table_headings.phone_number")}}</td>
        <td>{{$t("flexben.import.table_headings.cnp")}}</td>
        <td>{{$t("flexben.beneficiaries.fields.employee_id")}}</td>
        <td>{{$t("flexben.import.table_headings.benefit_group")}}</td>
        <td>{{ $t('flexben.import.table_headings.up_dejun_enable_auto_topup') }}</td>
        <td>{{ $t('flexben.import.table_headings.up_dejun_ticket_value') }}</td>
        <td>{{ $t('flexben.import.table_headings.income_tax_percent') }}</td>
        <td>{{ $t('flexben.import.table_headings.cass_percent') }}</td>
        <td>{{ $t('flexben.import.table_headings.cas_percent') }}</td>
      </tr>
      </thead>
      <tbody>
      <template v-if="import_items.length">
        <tr v-for="(item, index) in import_items" :key="index"
            class="trhover">
          <td>{{item.last_name}} {{item.first_name}}</td>
          <td>
            <span
              :class="'import-status-item-'+item.status">{{ $t('flexben.import.item_statuses.'+item.status) }}</span>
            <span v-if="item.invalid_reasons !== null" :id="'invalid_tooltip_'+index"
                  class="ml-1 item-error-reason">!</span>
            <b-tooltip v-if="item.invalid_reasons !== null"
                       :target="'invalid_tooltip_'+index" variant="flexben"
                       placement="topleft">
              <div v-html="getInvalidReasons(item.invalid_reasons)"></div>
            </b-tooltip>
          </td>
          <td>{{item.invitation_email}}</td>
          <td>{{item.phone_number}}</td>
          <td>{{item.cnp}}</td>
          <td>{{item.employee_number}}</td>
          <td>{{item.benefit_category_code}}</td>
          <td>{{ item.up_dejun_enable_auto_topup ? $t('flexben.general.yes') : $t('flexben.general.no') }}</td>
          <td>{{ (item.up_dejun_enable_auto_topup && item.up_dejun_ticket_value) ? item.up_dejun_ticket_value : '-' }}</td>
          <td>{{ item.income_tax_percent ? item.income_tax_percent : '-' }}</td>
          <td>{{ item.cas_percent ? item.cas_percent : '-' }}</td>
          <td>{{ item.cass_percent ? item.cass_percent : '-' }}</td>
        </tr>
      </template>
      <template v-else>
        <tr class="gri-cell text-center trhover">
          <td colspan="7">{{ $t("flexben.general.no_results_found") }}</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {BTooltip} from "bootstrap-vue";

  export default {
    name: "TableTypeBeneficiary",
    components: {
      'b-tooltip': BTooltip
    },
    props: {
      importItems: {
        type: Array,
        default: function () {
          return [];
        },
        required: true,
      }
    },
    computed: {
      import_items: function () {
        return this.importItems;
      }
    },
    methods: {
      getInvalidReasons(invalidReasons) {
        let errorList = [];
        let indexKey, errorField;
        for (errorField in invalidReasons) {
          if (typeof invalidReasons[errorField] === 'string') {
            errorList.push(this.$t('flexben.formFieldError', {
              field: this.$t('flexben.import.table_headings.' + errorField),
              reason: this.$t('flexben.formErrorReasons.' + invalidReasons[errorField])
            }))
          } else {
            for (indexKey in invalidReasons[errorField]) {
              errorList.push(this.$t('flexben.formFieldError', {
                field: this.$t('flexben.import.table_headings.' + errorField),
                reason: this.$t('flexben.formErrorReasons.' + invalidReasons[errorField][indexKey])
              }))
            }
          }
        }
        return errorList.join('<br>');
      },
    }
  }
</script>
